// React
import React from 'react'

// Animation
import { motion } from 'framer-motion'

// Utils
import { Join } from '@/lib/utils'

interface ProcessingProps {
  mode: 'dots' | 'question'
  className?: string
  classNames?: string
  elementId?: string
}

export const Processing: React.FC<ProcessingProps> = ({
  mode,
  className = 'text-blue-400',
  classNames = '',
  elementId,
}) => {
  const createSymbolContent = (symbol: string) => (
    <>
      <span>{symbol}</span>
      <span>{symbol}</span>
      <span>{symbol}</span>
      <span></span>
    </>
  )

  let content: React.ReactNode
  switch (mode) {
    case 'dots':
      content = createSymbolContent('.')
      break
    case 'question':
      content = createSymbolContent('?')
      break
    default:
      content = createSymbolContent('.')
      break
  }

  return (
    <motion.div
      key={elementId}
      className="flex justify-start"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.1 }}
    >
      <div className={Join('text-sm text-gray-300/90', classNames)}>
        <div className="mb-1">
          <div className={Join(className, 'h-6 overflow-hidden')}>
            <div
              className="grid grid-cols-4"
              style={{
                animation: 'ds-cl-chat-reveal 2s step-start infinite',
                width: 'fit-content',
              }}
            >
              {content}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}
